import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useYield = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const schema = useMemo(() => createRangeSchema({ bounds: filters?.yield }), [filters?.yield]);

  return useRangeFilter({ fromKey: 'includedYieldFrom', toKey: 'includedYieldTo', schema });
};

export default useYield;
